import React from 'react';

import MobileNavigation from './MobileNavigation';
import DesktopNavigation from './DesktopNavigation';
import SkipLink from './SkipLink';
import Brand from './Brand';
import {useAppContext} from '../hooks';
import {cx} from '../util';

const HeaderContainer = ({
  isSticky = false,
  isFixed = false,
  className,
  children,
}) => (
  <nav className={cx('font-heading bg-white px-4 lg:px-8 z-10', {
    'sticky top-0 shadow': isSticky,
    'fixed top-0 shadow w-full': isFixed,
    'border-b border-gray-200': !isSticky && !isFixed,
  }, className)}
  >
    <div className="w-full flex items-center justify-between">{children}</div>
  </nav>
);

const HeaderLogo = ({className}) => (
  <Brand
    className={cx('shrink-0 mr-0.5', className)}
    markClassName="h-6 w-6 mr-2"
    wordmarkClassName="mt-px flex md:hidden lg:flex"
    fkaBadge
  />
);

const Header = ({upgradeLink = '/upgrade?src=nav', isSticky = false, isFixed = false}) => {
  const {loading} = useAppContext();
  const pendingNavClassName = loading && 'invisible pointer-events-none';

  return (
    <>
      <SkipLink />
      <HeaderContainer isSticky={isSticky} isFixed={isFixed}>
        <HeaderLogo className={pendingNavClassName} />
        <DesktopNavigation upgradeLink={upgradeLink} className={pendingNavClassName} />
        <MobileNavigation upgradeLink={upgradeLink} className={pendingNavClassName} />
      </HeaderContainer>
    </>
  );
};

export const MinimalHeader = ({rightButton = undefined, ...props}) => (
  <>
    <SkipLink />
    <HeaderContainer className="flex items-center py-4 md:h-16" {...props}>
      <HeaderLogo />
      {rightButton}
    </HeaderContainer>
  </>
);

export default Header;
